import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'
import { Header } from 'sfy-react'
import { ReactComponent as InfoIcon } from './assets/images/info.svg'
import { ReactComponent as LogoutIcon } from './assets/images/logout.svg'
import ApproverListModal from './common/components/UIComponents/ApproverListModal/ApproverListModal'
import Navbox from './common/components/UIComponents/Navbox'
import { postRequestAsync } from './common/genericApi'
import { setLoader } from './store/common'

const AuthorizedRoute = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const rightPanel = useRef()
  // const accessToken = readCookie('central')

  const [showModal, setShowModal] = useState(false)

  // Access routes
  const access = localStorage.getItem('access')
  const parsedAccess = JSON.parse(access) || []
  const routeData = [...parsedAccess].map((eachAccess) => ({
    key: eachAccess?.appCode,
    name: eachAccess?.appName,
    path: eachAccess?.appRelativePath,
    icon: <img src={eachAccess?.appIconURL} prop={eachAccess.appName} alt='App Icon' />,
  }))

  const changeRoute = async (path) => {
    history.push(path)
  }

  const handleOnLogout = async () => {
    try {
      dispatch(setLoader(true))
      let response = await postRequestAsync('/user/logout', {})
      if (!response.success) {
        throw new Error(response.message)
      }

      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('email')
      localStorage.removeItem('access')

      dispatch(setLoader(false))
      window.location = '/login'
    } catch (e) {
      console.log(e)
      if (e.statusCode === 'SFY.USER.4001' || e.statusCode === 'SFY.USER.4006') {
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('email')
        localStorage.removeItem('access')
        window.location = '/login'
      }
      dispatch(setLoader(false))
    }
  }

  const verifyJsonWebToken = async () => {
    try {
      dispatch(setLoader(true))
      const response = await postRequestAsync('/user/verifyJsonWebToken', {})
      if (!response.success) {
        throw new Error(response.message)
      }

      dispatch(setLoader(false))
    } catch (e) {
      console.log(e)
      if (e.statusCode === 'SFY.USER.4000' || e.statusCode === 'SFY.USER.4006' || e.statusCode === 'SFY.USER.40400706') {
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('email')
        localStorage.removeItem('access')
        localStorage.setItem('invalidSession', true)
      }
      dispatch(setLoader(false))
    }
  }

  useEffect(() => {
    verifyJsonWebToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleRequestAccess = () => {
    localStorage.setItem('isUpdateAccessRequest', true)
    window.open('/user/central/updateUserAccess')
  }

  return (
    <div className='d-flex'>
      <div ref={rightPanel} className='right-panel'>
        <Header
          className={{ header: 'logo p0 pl20 pr20', navLink: 'header-item' }}
          iconType='svg'
          brand={<img src={`/${window.appName}/images/servify_logo.svg`} className={`sidebar-image`} onClick={() => changeRoute('/')} alt='logo' />}
          navItems={[
            ...(process.env.REACT_APP_ENVIRONMENT !== 'xcentral'
              ? [
                  { title: <div className='header-item--request-access'>Request Access</div>, onClick: () => handleRequestAccess() },
                  {
                    title: '',
                    icon: (
                      <span className='header-item--approver-info'>
                        <InfoIcon title="Central Apps Approver's Info" />
                      </span>
                    ),
                    onClick: () => setShowModal(true),
                  },
                ]
              : []),
            {
              title: <div className='region-text'>{localStorage.getItem('selectedRegion')?.substring(0, 2)?.toUpperCase()}</div>,
            },
            {
              title: '',
              icon: <LogoutIcon title='Logout' />,
              onClick: handleOnLogout,
            },
          ]}
        />
        <ApproverListModal showModal={showModal} setShowModal={setShowModal} />
        <div className='layout'>
          <Navbox navItems={routeData} />
        </div>
        <Switch>
          {routeData.map((item) => (
            <Route key={item.name} exact path={item.path} component={item.component} />
          ))}
          <Redirect to='/' />
        </Switch>
        {/* <Footer className={{ footerContainer: 'footer' }}>
          <div className='footer__title'>
            <img src={`/${window.appName}/images/powered-by.png`} alt='footer' />
          </div>
          <div className='footer__trademark'>
            <div className='footer-trademark--text'>
              <p>Servify is a registered Trademark of Service Lee Technologies Private Limited. Copyright &copy; Servify 2023-2024</p>
            </div>
          </div>
        </Footer> */}
      </div>
    </div>
  )
}

export default AuthorizedRoute
